import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import glamorous from 'glamorous';
import { RvLoader } from '../../components/Loader';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { ChartCommonProps, IconButtonWrapper, ChartCommonState, HelpWrapper } from '../Common';
import { formatNumber, GetArrow, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
import { WithStyles, withStyles, IconButton } from '@material-ui/core';
import { styles } from '../styles';
import { ChartFilter } from '../ChartComponents';
import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    Scale,
    Tick,
    Chart,
    ChartEvent,
    ActiveElement,
} from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartEmptyState } from '../ChartEmptyState';
import { ChartNotes } from '../ChartNotes';
import ReceiptOutlinedIcon from '@material-ui/icons/ReceiptOutlined';
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    zoomPlugin
);

// tslint:disable-next-line:no-any
const CardWrapper = glamorous.div<{ theme?: any }>(props => ({
    // padding: 15,
    display: 'flex',
    flexFlow: 'column',
    textAlign: 'center',
    // fontSize: '18px',
    height: '100%',
    borderRadius: '8px',
    backgroundColor: '#FFFFFF',
    boxShadow: '0 0 14px 0 rgba(81,115,255,0.09)',
    width: '100%',
    '@media print': {
        alignItems: 'center',
        boxShadow: 'none !important'
    }
}));

const BarWrapper = glamorous.div<{ theme?: object }>((props) => ({
    position: 'relative',
    paddingBottom: '10px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    maxWidth: '100%',
    maxHeight: '100%',
    height: '100%',
}));

const BarTitleContainer = glamorous.div<{ theme?: object }>((props) => ({
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    padding: '15px 15px 0px 15px',
    fontSize: '16px',
    fontWeight: 600,
    [`& .${`h1`}`]: {

    },
    [`& .${`h2`}`]: {
        fontSize: '2.5rem',
        padding: '10px 0',
    },
})).withProps({ className: 'rv-chart-title-area' });

const BarContainer = glamorous.div<{ theme?: object }>((props) => ({
    padding: '5px 15px 15px 15px',
    minHeight: '300px',
    flex: 1,
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    maxHeight: '350px',
    maxWidth: 'auto',
    position: 'relative',
    '@media (max-width: 533px)': {
        maxWidth: '350px',
        margin: '0 auto',
    },
    [`& .${`titleWrapper`}`]: {
        textAlign: 'center',
        display: 'inline-block',
        width: '100%',
        padding: '15px',
        [`& .${`title`}`]: {
            fontSize: '18px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`value`}`]: {
            fontSize: '24px',
            fontWeight: 600,
            display: 'block',
            marginBottom: '15px',
        },
        [`& .${`secondary-title`}`]: {
            fontSize: '16px',
            fontWeight: 400,
            display: 'block',
            marginBottom: '15px',
        }
    }
}));

const LoadWrapper = glamorous.div<{ theme?: object }>((props) => ({
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
}));

const TotalDiv = glamorous.div<{ theme?: object }>((props) => ({
    cursor: 'pointer',
    paddingRight: 5
}));

export interface QueryDefaultType {
    loading?: boolean;
    // tslint:disable-next-line: no-any
    result?: any;
    // tslint:disable-next-line: no-any
    error?: any;
}

interface ChartProps extends SelectedItemProps, ChartCommonProps, WithStyles<typeof styles> {
    chartFilter?: ChartFilter;
}

interface ChartState extends ChartCommonState {
    // 
}

class InvoiceFeesBilledInLast12MonthsChart extends React.Component<ChartProps, ChartState>  {

    // tslint:disable-next-line: no-any
    public chartRef: React.RefObject<any>;

    constructor(props: ChartProps, state: ChartState) {
        super(props, state);
        this.onCloseChart = this.onCloseChart.bind(this);
        this.handlePopoverOpen = this.handlePopoverOpen.bind(this);
        this.handlePopoverClose = this.handlePopoverClose.bind(this);
        this.handleTotalClick = this.handleTotalClick.bind(this);
        this.onHover = this.onHover.bind(this);

        this.onPan = this.onPan.bind(this);

        this.chartRef = React.createRef();

        this.state = {
            open: false,
            anchorEl: undefined
        };
    }

    public componentDidMount() {
        // 
    }

    public componentWillUnmount() {
        // 
    }

    public render() {        
        // const { classes } = this.props;
        var symbol = '';
        return (
            <React.Fragment>
                {/* tslint:disable-next-line: no-any */}
                <Query<any> query={CurrencySymbol}>
                    {(result) => {

                        if (result.loading) {
                            return (
                                <ChartSkeleton variant="columns" />
                            );
                        }

                        const currencySymbol = (result.loading || result.error) ?
                            null : result.data.options.currencySymbol;

                        symbol = currencySymbol ? currencySymbol.symbol : null;

                        return (            
                            <CardWrapper>
                                {/* tslint:disable-next-line: no-any */}
                                <Query<any> 
                                    query={ChartData}
                                    variables={{
                                        entityType: this.props.chartFilter?.entityType,
                                        entityGuid: this.props.chartFilter?.entityGuid,
                                        responsibility: this.props.chartFilter?.responsibility,
                                        filter: this.props.chartFilter?.filter
                                    }}
                                > 
                                    {({ loading, error, data }) => {
                
                                        if (loading) {
                                            return (
                                                <LoadWrapper className="load-wrapper">
                                                    <RvLoader size="small" />
                                                </LoadWrapper>
                                            );
                                        }
                
                                        const statistics = data.statistics;
                
                                        let invoice = (loading || error ||
                                            statistics === null || statistics === undefined)
                                            ? null
                                            : statistics.invoice;
                
                                        let invoiceFeesBilledInLastTwelveMonth = invoice ? invoice.invoiceFeesBilledInLastTwelveMonth : null;
                
                                        if (invoiceFeesBilledInLastTwelveMonth) {                
                                            // tslint:disable-next-line: max-line-length
                                            const lastTwelveMonthsTotalCount = invoiceFeesBilledInLastTwelveMonth.invoiceTwelveMonthsTotalCount.lastTwelveMonthsTotalCount;
                                            // tslint:disable-next-line:max-line-length
                                            const previousTwelveMonthsTotalCount = invoiceFeesBilledInLastTwelveMonth.invoiceTwelveMonthsTotalCount.previousTwelveMonthsTotalCount;
                
                                            // tslint:disable-next-line: no-any
                                            let months = invoiceFeesBilledInLastTwelveMonth.invoiceByMonth.map((value: any) => { 
                                                return value.month; });

                                            // tslint:disable-next-line: no-any
                                            let years = invoiceFeesBilledInLastTwelveMonth.invoiceByMonth.map((value: any) => { 
                                                return value.year; });
                
                                            let highestValue = 0;

                                            // tslint:disable-next-line: no-any
                                            let counts = invoiceFeesBilledInLastTwelveMonth.invoiceByMonth.map((value: any) => { 
                                                if ( value.count > highestValue) {
                                                    highestValue = value.count;
                                                }
                                                return value.count; 
                                            });
                
                                            // tslint:disable-next-line: no-any
                                            let trendCounts = invoiceFeesBilledInLastTwelveMonth.trend.map((value: any) => {
                                                if ( value.count > highestValue) {
                                                    highestValue = value.count;
                                                }
                                                return value.count;
                                            });
                
                                            return (
                                                <BarWrapper className={RV_CHART_CLASS}>
                                                    <IconButtonWrapper
                                                        aria-label="close"
                                                    >
                                                        <HelpWrapper className="rv-chart-help">
                                                            <ChartInfo 
                                                                description={this.props.description}
                                                            />
                                                        </HelpWrapper>
                                                        <IconButton
                                                            aria-label="close"
                                                            onClick={this.onCloseChart}
                                                            size="small"
                                                        >
                                                            <CloseIcon />
                                                        </IconButton>
                                                    </IconButtonWrapper>
                                                    <BarTitleContainer>
                                                        <ChartHeading icon={<ReceiptOutlinedIcon />} title="Fees Billed in Last 12 Months" />
                                                        <TotalDiv className="h2" onClick={() => this.handleTotalClick(true)}>
                                                            <AnimatedNumber value={lastTwelveMonthsTotalCount} format={(amount) => symbol + formatNumber(amount)} />
                                                            {GetArrow(lastTwelveMonthsTotalCount, previousTwelveMonthsTotalCount)}
                                                        </TotalDiv>
                                                        <div className="h3">
                                                            <TotalDiv onClick={() => this.handleTotalClick(false)}>
                                                                {symbol + formatNumber(previousTwelveMonthsTotalCount)} 
                                                            </TotalDiv>                                                            
                                                            in the 12 months before that
                                                        </div>
                                                    </BarTitleContainer>
                                                    <BarContainer className="rv-chart-bars">
                                                        <Bar
                                                            ref={this.chartRef}
                                                            // tslint:disable-next-line: no-any
                                                            onClick={(event: React.MouseEvent<any>) => {
                                                                const _data = getElementAtEvent(this.chartRef.current, event);
                                                                if (_data.length > 0 && this.props.getSelectedItem) {
                
                                                                    const _index = getElementAtEvent(this.chartRef.current, event)[0].index;
                
                                                                    const item = months[_index];
    
                                                                    const searchCriterias = new Array<SearchCriteria>();
                
                                                                    // Pass property and month range. 
                                                                    // Comparison value should be in month/ MMM as displayed in the graph
                                                                    // . e.g. - Jan, Feb, etc
                                                                    searchCriterias.push(
                                                                        { property: 'Status', operator: 'in', comparison: 'Billed' },
                                                                        { property: 'InvoiceDateMonth', operator: 'eq', comparison: item },
                                                                        { property: 'InvoiceDateYear', operator: 'eq', comparison: years[_index] }
                                                                    );
                
                                                                    return this.props.getSelectedItem(
                                                                        searchCriterias,
                                                                        false,
                                                                        'Fees Billed in Last 12 Months -' + item,
                                                                        DrillDownType.invoiceSummary,
                                                                        'Invoices'
                                                                    );
                                                                }
                                                            }}
                                                            data={{
                                                                labels: getLabels(months),
                                                                datasets: [
                                                                    {
                                                                        // fill: false,
                                                                        label: 'Fees Billed',
                                                                        ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                                                        data: counts,
                                                                        type: 'bar'
                                                                    },
                                                                    {
                                                                        // fill: false,
                                                                        // label: 'Matter Opened',
                                                                        backgroundColor: RV_CHART_COLORS.primary,
                                                                        borderColor: RV_CHART_COLORS.primary,
                                                                        borderWidth: 3,
                                                                        hoverBackgroundColor: RV_CHART_COLORS.primary,
                                                                        hoverBorderColor: RV_CHART_COLORS.primary,
                                                                        tension: 0.35,
                                                                        pointRadius: 0,
                                                                        data: trendCounts,
                                                                        type: 'line',
                                                                        pointStyle: 'dash',
                                                                        borderDash: [10, 5],
                                                                    }
                                                                // tslint:disable-next-line: no-any
                                                                ] as any
                                                            }}
                                                            options={{
                                                                onHover: this.onHover,
                                                                indexAxis: 'x' as const,
                                                                animation: rvChartAnimation(),
                                                                elements: { bar: { borderWidth: 0 } },
                                                                responsive: true,
                                                                maintainAspectRatio: false,
                                                                scales: {
                                                                  y: {
                                                                    grid: rvValueAxisStyle.grid,
                                                                    // beginAtZero: true,
                                                                    suggestedMax: getSuggestedMaxTick([...counts, ...trendCounts]),
                                                                    beginAtZero: true,
                                                                    ticks: {
                                                                        ...rvValueAxisStyle.ticks,
                                                                        maxTicksLimit: getMaxTickLimit([...counts, ...trendCounts]),
                                                                        autoSkip: false,
                                                                        callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                                                            return `${symbol}${formatNumber(tickValue)}`;
                                                                        }
                                                                    }
                                                                  },
                                                                  x: {
                                                                    grid: rvCategoryAxisStyle.grid,
                                                                    // min: 0,
                                                                    // max: 9 // minimum display
                                                                    ticks: {
                                                                        ...rvCategoryAxisStyle.ticks,
                                                                        autoSkip: false
                                                                    }
                                                                  }
                                                                },
                                                                plugins: {
                                                                  legend: {
                                                                    position: 'bottom' as const,
                                                                    display: false
                                                                  },
                                                                  title: {
                                                                    display: false,
                                                                    text: `Fees Billed in the last 12 months: ${symbol + formatNumber(lastTwelveMonthsTotalCount)}`,
                                                                  },
                                                                  zoom: {
                                                                    pan: {
                                                                      enabled: false,
                                                                      onPan: this.onPan
                                                                    },
                                                                    zoom: {
                                                                      wheel: {
                                                                        enabled: false
                                                                      }
                                                                    }
                                                                    // limits: {
                                                                    //   y: { min: 0, max: 9 },
                                                                    // },
                                                                  },
                                                                  tooltip: {
                                                                    ...rvTooltipStyle,
                                                                    callbacks: {
                                                                        // tslint:disable-next-line: no-any
                                                                        label: function (context: any) {
                                                                            const { 
                                                                                //   dataIndex, 
                                                                                //   label, 
                                                                                formattedValue,
                                                                                //   dataset 
                                                                            } = context;
                    
                                                                            var currentValue = parseFloat(formattedValue.replace(/,/g, ''));
        
                                                                            return `Fees Billed: ${symbol}${formatNumber(currentValue)}`;
                                                                        },
                                                                    }
                                                                  }
                                                                },
                                                            }}
                                                        />
                                                        {isChartDataEmpty(counts, trendCounts) && (
                                                            <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                                                        )}
                                                    </BarContainer>
                                                    <ChartNotes notes={['Information collated based on matter responsibility']} actionHint="Drill down to invoice details" />
                                                </BarWrapper>
                                            );
                                        }
                
                                        return (
                                            <LoadWrapper className="load-wrapper">
                                                <RvLoader size="small" />
                                            </LoadWrapper>
                                        );
                                }}
                                </Query>                
                            </CardWrapper>
                        );
                    }}
                </Query>
            </React.Fragment>
        );
    }

    private handleTotalClick(isCurrent: Boolean) {
        if (this.props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push(
                { property: 'Status', operator: 'in', comparison: 'Billed' },
                { property: '12MonthPeriod', operator: 'eq', comparison: isCurrent ? 'curr' : 'prev' }
            );

            return this.props.getSelectedItem(
                searchCriterias,
                false,
                'Fees Billed in Last 12 Months',
                DrillDownType.invoiceSummary,
                'Invoices'
            );
        }        
    }

    private onCloseChart() {
        if (this.props.onCloseChart) {
            return this.props.onCloseChart('isFeesBilledInLast12MonthsOpen');
        }
    }

    // tslint:disable-next-line: no-any
    private handlePopoverOpen(event: any) {
        this.setAnchorEl(event.currentTarget);
    }

    private handlePopoverClose = () => {
        this.setAnchorEl(null);
    }

    // tslint:disable-next-line: no-any
    private setAnchorEl(anchorElValue: any) {
        this.setState({
            anchorEl: anchorElValue,
            open: Boolean(anchorElValue)
        });
    }

    private onPan = (context: { chart: Chart }) => {
        this.chartRef.current.options.scales.y.min = 0;
        this.chartRef.current.update();
    }

    private onHover(event: ChartEvent, elements: ActiveElement[], chart: Chart) {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    }
}

// tslint:disable-next-line: no-any
export default withStyles(styles as any, { withTheme: true })(InvoiceFeesBilledInLast12MonthsChart as any) as any;

const CurrencySymbol = gql`query CurrencySymbol {
    options {currencySymbol {symbol}}
}`;

const ChartData = gql`
    query InvoiceFeesBilledInLast12MonthsData ($entityType: Int, $entityGuid: String, $responsibility: Int, $filter: String) {
        statistics {
            invoice {
                invoiceFeesBilledInLastTwelveMonth (entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility, filter: $filter) {
                    invoiceTwelveMonthsTotalCount {
                        previousTwelveMonthsTotalCount
                        lastTwelveMonthsTotalCount
                    }
                    invoiceByMonth {
                        month
                        year
                        count
                    }
                    trend {
                        month
                        count
                    }
                }          
            }
        }
    }
`;
